import React from 'react';
import { Badge } from 'react-bootstrap';
import { TriggeredRule } from './types';
import { formatDateTime, formatAmount } from './amlUtils';

interface Props {
  rules: TriggeredRule[];
}

// Отображение сработавших AML-правил
const AmlRules: React.FC<Props> = ({ rules }) => {
  const severityBadge = (sev: string) => {
    const map: Record<string, string> = {
      critical: 'danger',
      high:     'warning',
      medium:   'info',
      low:      'secondary',
    };
    const labels: Record<string, string> = {
      critical: 'Критический',
      high:     'Высокий',
      medium:   'Средний',
      low:      'Низкий',
    };
    return (
      <Badge bg={map[sev] || 'light'} text={sev === 'low' ? 'dark' : undefined}>
        {labels[sev] || sev}
      </Badge>
    );
  };

  if (rules.length === 0) {
    return <p className="text-muted">Нет сработавших правил</p>;
  }

  return (
    <div className="d-flex flex-column gap-3">
      {rules.map((rule, idx) => (
        <div key={idx} className="border rounded p-3">
          <div className="d-flex justify-content-between align-items-start mb-1">
            <div>
              <span className="badge bg-secondary me-2" style={{ fontFamily: 'monospace' }}>
                {rule.ruleCode}
              </span>
              <span className="fw-semibold">{rule.ruleName}</span>
            </div>
            {severityBadge(rule.severity)}
          </div>

          <p className="text-muted small mb-1">{rule.details}</p>

          <div className="d-flex gap-3 flex-wrap" style={{ fontSize: '0.8rem' }}>
            <span className="text-muted">
              Сработало: {formatDateTime(rule.triggeredAt)}
            </span>
            {rule.transactionId && (
              <span className="text-muted">
                Транзакция: <code>{rule.transactionId}</code>
              </span>
            )}
            {rule.amount != null && rule.currency && (
              <span className="text-muted">
                Сумма: <strong>{formatAmount(rule.amount, rule.currency)}</strong>
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AmlRules;
